const SlotTypeChoices = [
  { id: 'block', name: 'Block' },
  { id: 'inline', name: 'Inline' },
  { id: 'inline_left', name: 'Inline Left' },
  { id: 'inline_right', name: 'Inline Right' }
];

export default SlotTypeChoices;



// WEBPACK FOOTER //
// ./src/views/Components/Placements/StaticData/SlotTypeChoices.tsx